// src/pages/Datenschutz.jsx
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/skilt-technical-logo-blau.png";
import "../styles/Datenschutz.css";

function Datenschutz() {
  return (
    <section className="datenschutz">
      <div className="datenschutz-container">
        <Link to="/">
          <img
            src={logo}
            alt="Skilt Technical"
            className="datenschutz-logo"
          />
        </Link>

        <h1>Datenschutzerklärung</h1>

        <h2>1 Verantwortlicher</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:
        </p>
        <p>
          Skilt Technical UG (haftungsbeschränkt)<br />
          Gubener Str. 36A<br />
          03149 Forst (Lausitz)
        </p>
        <p>
          E-Mail: info@skilt.app
        </p>

        <h2>2 Allgemeine Hinweise zur Datenverarbeitung</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen.
          Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
          den gesetzlichen Datenschutzvorschriften sowie dieser
          Datenschutzerklärung.
        </p>
        <p>
          Die Nutzung dieser Website ist grundsätzlich ohne Angabe
          personenbezogener Daten möglich.
        </p>

        <h2>3 Hosting und Server-Logfiles</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Beim Besuch dieser Website werden automatisch Informationen durch den
          Hostinganbieter erfasst und in sogenannten Server-Logfiles gespeichert.
        </p>
        <p>Erfasst werden können insbesondere:</p>
        <p>
          • IP-Adresse<br />
          • Datum und Uhrzeit der Serveranfrage<br />
          • Browsertyp und Browserversion<br />
          • verwendetes Betriebssystem<br />
          • Referrer-URL<br />
          • Hostname des zugreifenden Rechners
        </p>
        <p>
          Diese Daten sind technisch erforderlich, um die Website korrekt
          auszuliefern und die Stabilität und Sicherheit des Servers zu
          gewährleisten.
        </p>
        <p>
          Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse am sicheren Betrieb der Website).
        </p>
        <p>
        Das Hosting dieser Website erfolgt über die IONOS SE, Deutschland.
        </p>

        <p>
        Eine Übermittlung Ihrer Daten in Drittstaaten außerhalb der EU erfolgt nicht.
        </p>

        <h2>4 Kontaktaufnahme per E-Mail</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Wenn Sie uns per E-Mail kontaktieren, werden die von Ihnen
          übermittelten Daten, z. B. Ihre E-Mail-Adresse und der Inhalt Ihrer
          Nachricht, zur Bearbeitung Ihrer Anfrage gespeichert.
        </p>
        <p>
          Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
          lit. b DSGVO, sofern Ihre Anfrage mit der Anbahnung oder Durchführung
          eines Vertrags zusammenhängt. In allen übrigen Fällen erfolgt die
          Verarbeitung auf Grundlage unseres berechtigten Interesses an der
          Bearbeitung Ihrer Anfrage gemäß Art. 6 Abs. 1 lit. f DSGVO.
        </p>
        <p>
          Ihre Daten werden gelöscht, sobald Ihre Anfrage abschließend bearbeitet
          wurde und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </p>

        <h2>5 Keine Verwendung von Tracking- oder Analyse-Tools</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Auf dieser Website werden keine Tracking- oder Analyse-Tools
          eingesetzt. Es findet keine Auswertung Ihres Nutzerverhaltens zu
          Analyse- oder Marketingzwecken statt.
        </p>

        <h2>6 Cookies</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Diese Website verwendet keine Cookies, die personenbezogene Daten
          verarbeiten.
        </p>

        <h2>7 Externe Links</h2>
        <div className="datenschutz-divider"></div>
        <p>
        Diese Website kann Links zu externen Websites und Plattformen enthalten.
        </p>
        <p>
        Für die Inhalte und Datenschutzpraktiken der verlinkten Seiten sind
        ausschließlich deren jeweilige Betreiber verantwortlich.
        </p>

        <h2>8 Ihre Rechte</h2>
        <div className="datenschutz-divider"></div>
        <p>Sie haben jederzeit das Recht auf:</p>
        <p>
          • Auskunft über Ihre gespeicherten personenbezogenen Daten<br />
          • Berichtigung unrichtiger Daten<br />
          • Löschung Ihrer Daten<br />
          • Einschränkung der Verarbeitung<br />
          • Datenübertragbarkeit<br />
          • Widerspruch gegen die Verarbeitung Ihrer Daten
        </p>
        <p>
          Zur Ausübung Ihrer Rechte können Sie sich jederzeit an die oben genannte
          Kontaktadresse wenden.
        </p>

        <h2>9 Beschwerderecht bei einer Aufsichtsbehörde</h2>
        <div className="datenschutz-divider"></div>
        <p>
        Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren.
        Zuständig ist z. B.:
        </p>

        <p>
        Landesbeauftragte für den Datenschutz und für das Recht auf Akteneinsicht Brandenburg
        </p>

        <h2>10 Änderungen dieser Datenschutzerklärung</h2>
        <div className="datenschutz-divider"></div>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich
          rechtliche Anforderungen oder technische Änderungen ergeben.
        </p>
      </div>
    </section>
  );
}

export default Datenschutz;